// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1ZE7O","dragIcon":"Choice_dragIcon__3QBAl","left":"Choice_left__cynz3","input":"Choice_input__3FoWf"};